export default __webpack_public_path__ + "static/HalvarBreit-Blk-10c0e675e008e93614af2fa58cc005ac.woff2";